import React from "react";

export default ({ message, infoClassName }) => {
  return (
    <div className="is-mobile is-content-centered">
      <div className="box">
        <div className={`notification ${infoClassName}`}>{message}</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/InfoBox/index.js